import { render, staticRenderFns } from "./bdd-restrictions-register.vue?vue&type=template&id=9c616306"
import script from "./bdd-restrictions-register.vue?vue&type=script&lang=js"
export * from "./bdd-restrictions-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports